import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40ff1aec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-control" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Ist die Adresse des Hauptsitzes identisch mit der juristischen Adresse?", -1))
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Adresse des Hauptsitzes")
], -1))
const _hoisted_7 = { class: "form-control" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_request_base_address = _resolveComponent("request-base-address")!
  const _component_base_toggle = _resolveComponent("base-toggle")!
  const _component_base_button = _resolveComponent("base-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (!_ctx.formValid)
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, "Adressdaten überprüfen"))
        : (!_ctx.addressValid)
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, "Adresse wurde nicht gefunden"))
          : _createCommentVNode("", true)
    ]),
    _createVNode(_component_request_base_address, {
      type: 'stepper-address',
      onInterface: _ctx.getAddressInterface,
      onValidForm: _ctx.validAddress
    }, null, 8, ["onInterface", "onValidForm"]),
    _hoisted_4,
    _createVNode(_component_base_toggle, {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.value = !_ctx.value)),
      value: _ctx.value,
      reverse: true,
      height: '28',
      width: '55',
      "font-size": '18',
      checkedDotColor: 'white',
      uncheckedDotColor: '#173166',
      checkedText: '',
      uncheckedText: '',
      checkedBg: '#173166',
      uncheckedBg: 'lightgrey'
    }, null, 8, ["value"]),
    (!_ctx.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            (!_ctx.formJuValid)
              ? (_openBlock(), _createElementBlock("p", _hoisted_8, " Adressdaten des Hauptsitzes überprüfen"))
              : (!_ctx.addressJuValid)
                ? (_openBlock(), _createElementBlock("p", _hoisted_9, " Adresse des Hauptsitzes wurde nicht gefunden"))
                : _createCommentVNode("", true)
          ]),
          _createVNode(_component_request_base_address, {
            type: 'stepper-ju-address',
            onInterface: _ctx.getAddressJuInterface,
            onValidForm: _ctx.validJuAddress
          }, null, 8, ["onInterface", "onValidForm"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_base_button, {
        title: 'Zurück',
        onClick: _ctx.backToCompany
      }, null, 8, ["onClick"]),
      _createVNode(_component_base_button, {
        title: 'Weiter',
        onClick: _ctx.submitAddress
      }, null, 8, ["onClick"])
    ])
  ], 64))
}